/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { cookingStateEnumSchema } from "./cookingStateEnumSchema.ts";
import { itemTypeSchema } from "./itemTypeSchema.ts";

export const arrivalsOrderItemSchema = z.object({
	name: z.string().max(100),
	type: itemTypeSchema.describe("* `food` - Еда\n* `drink` - Напиток"),
	cooking_state: cookingStateEnumSchema.optional().describe("* `0` - Создан\n* `1` - Готовится\n* `2` - Приготовлен\n* `3` - Выдан"),
});
